const PinIcon = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" />
    <circle cx="12" cy="10" r="2.4" />
  </svg>
);
const ChevronIcon = (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m6 9 6 6 6-6" />
  </svg>
);

// Plain "deliver to" display, pin + area name + chevron — no pill background,
// no dropdown/drawer, no second address line. Clicking it re-runs detection
// in place; the label just updates inline once done. An error replaces the
// label text itself rather than a dropped second line.
export default function LocationPicker({ loc, busy, error, onClick }) {
  const label = busy ? "Detecting…" : error || (loc ? loc.label : "Set location");
  return (
    <button type="button" className="hdr__loc" onClick={onClick} title="Click to re-detect your location">
      <span className="hdr__loc-pin">{PinIcon}</span>
      <span className={`hdr__loc-text ${error ? "hdr__loc-text--error" : ""}`}>
        <strong>{label}</strong>
      </span>
      <span className="hdr__loc-chev">{ChevronIcon}</span>
    </button>
  );
}
